/**
 * BUG-042 — ApiError, split out of api.ts so it can be imported without
 * pulling in the rest of that module (which reads `import.meta.env` at
 * module scope — fine under Vite, but crashes when a plain-node test
 * imports it outside a Vite runtime). api.ts re-exports this for existing
 * callers; new code importing just the error type/class should prefer
 * this module directly.
 */
export class ApiError extends Error {
  status: number;
  body: string;
  constructor(status: number, body: string, message?: string) {
    super(message ?? `${status} ${body || "API error"}`);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}

/**
 * The `{ error, message }` a route answered with, parsed from `body`.
 * Empty when the error is not an ApiError or its body is not that JSON.
 */
export function apiErrorPayload(err: unknown): { error?: string; message?: string } {
  if (!(err instanceof ApiError) || !err.body) return {};
  try {
    const parsed = JSON.parse(err.body) as unknown;
    if (parsed == null || typeof parsed !== "object") return {};
    const { error, message } = parsed as { error?: unknown; message?: unknown };
    return {
      error: typeof error === "string" ? error : undefined,
      message: typeof message === "string" ? message : undefined,
    };
  } catch {
    return {};
  }
}
